export default {
	updateCriteriaSetups(state, payload) {
		state.CriteriaSetups = payload;
	}
};
